<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tzWkXc/images/cover.jpg?1685327251388" alt="This image is the cover for the book Pretty Sally Couldn't Marry Albert, A Valentine Rainbow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pretty Sally Couldn't Marry Albert, A Valentine Rainbow
      </h1>
      <p class="bookDescription body article font2">
        <p>Recovering from a stroke, Albert struggles to help his sister deal with her husband's death and the demands of single parenthood. Everyone puts on a brave face, but the family is overwhelmed and left with a hole in their hearts. The discovery of a stash of old valentines makes Albert nostalgic for the sunny days spent with his childhood friend, Harry. Albert's nephew, Kyle, decides to find the long-lost Harry only to discover life hasn't been kind to Harry either.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jefferson Parrish
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2078d67c